import javaService from "../../utils/request"
function handel(data) {
  var params = new URLSearchParams()
  for (const key in data) {
    params.append(key, data[key])
  }
  return params
}

//修改用户名
export function editUserName(data){
  return javaService({
    url: '/user/updateNickName',
    method: 'post',
    data: handel(data),
    isLoading:true
  })
}

//修改手机号
export function editUserPhone(data){
  return javaService({
    url: '/user/changeMobile',
    method: 'post',
    data: handel(data),
    isLoading:true
  })
}

//修改密码
export function editUserPassword(data){
  return javaService({
    url: '/user/updatePass',
    method: 'post',
    data: handel(data),
    isLoading:true
  })
}